var exports = {
  "K": "LayoutHeader__msh8il",
};

module.exports = exports;
